import { WelcomeBanner, KPICardsRow } from '../../components/overview';
import { overviewPageContent } from '../../content';
import { useFilter } from '../../contexts/FilterContext';
import type { OverviewKpiApiValues } from './types';

interface OverviewHeroSectionProps extends OverviewKpiApiValues {
  clientName: string;
  portfolioSummaryTags: string[];
  loading: boolean;
}

export function OverviewHeroSection({
  clientName,
  portfolioValue,
  netAnnualRentYield,
  ttmRoi,
  undistributedEarnings,
  netEquity,
  ttmCashReceived,
  portfolioCoc,
  portfolioNoiYield,
  capitalAtRisk,
  capitalAtRiskFootnote,
  portfolioSummaryTags,
  loading,
}: OverviewHeroSectionProps) {
  const { periodMode } = useFilter();

  return (
    <section className="overview-layout__hero">
      <WelcomeBanner
        clientName={clientName}
        portfolioSummaryTags={portfolioSummaryTags}
        subtitle={overviewPageContent.subtitle}
        loading={loading}
      />
      <div className="overview-layout__kpis">
        <KPICardsRow
          portfolioValue={portfolioValue}
          netAnnualRentYield={netAnnualRentYield}
          ttmRoi={ttmRoi}
          undistributedEarnings={undistributedEarnings}
          netEquity={netEquity}
          ttmCashReceived={ttmCashReceived}
          portfolioCoc={portfolioCoc}
          portfolioNoiYield={portfolioNoiYield}
          capitalAtRisk={capitalAtRisk}
          capitalAtRiskFootnote={capitalAtRiskFootnote}
          loading={loading}
          periodMode={periodMode}
        />
      </div>
    </section>
  );
}
